// extracted by mini-css-extract-plugin
module.exports = {"erroBoundaryContainer":"styles_erroBoundaryContainer__UeA-d","logoContainer":"styles_logoContainer__2BGBc"};